"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * This can be passed as a child to the `SearchField` component to render a
 * selectable search suggestion in a popover below that component.
 */
var SearchSuggestion = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(SearchSuggestion, _React$Component);

  var _super = _createSuper(SearchSuggestion);

  function SearchSuggestion() {
    (0, _classCallCheck2["default"])(this, SearchSuggestion);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(SearchSuggestion, [{
    key: "render",
    value: function render() {
      // Actual rendering is done via the internal `OptionListItem` component. See
      // ./search-suggestion-popover.js for the implementation.
      return null;
    }
  }]);
  return SearchSuggestion;
}(_react["default"].Component);

SearchSuggestion.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The contents of the suggestion.
   *
   * If this is a plain string then matching substrings will automatically be
   * highlighted based on the value of the search field.
   *
   * If this is a function then it will receive an object containing the
   * following keys:
   * - `suggestion` - the value of the `suggestion` prop
   * - `query` - the current value of the search field
   * - `highlighted` - a boolean indicating whether or not the suggestion should
   *   be shown in a highlighted state (this will be true if the user focuses
   *   on the suggestion or if they select it).
   */
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]).isRequired,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * A unique value representing the current suggestion.
   */
  suggestion: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * This is called when the user selects the suggestion. The value of the
   * `suggestion` prop is passed as the only argument to this function.
   */
  onClick: _propTypes["default"].func
} : {};
var _default = SearchSuggestion;
exports["default"] = _default;